var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:_vm.getClasses(),attrs:{"aria-expanded":"{isActive}"},on:{"click":function($event){return _vm.showMenu()}}},[_c('span')])}
var staticRenderFns = []

export { render, staticRenderFns }